/** @jsx React.DOM */
var React = require('react/addons')
var remotes = require('../../../helpers/remotes')
var num = require('num')
var numbers = require('../../../helpers/numbers')
var constants = require('../../../helpers/constants')
var formatters = require('../../../helpers/formatters')
var config = require('json!../../../config.json')

var ServerInfo = React.createClass({displayName: 'ServerInfo',
  getInitialState: function() {
    return {}
  },

  componentWillMount: function() {
    document.title = 'RMC' + config.documentTitleSuffix

    var remote = remotes.nodes
    remote.requestLedger(null, [], function(err, res) {
      if (err) throw err
      // console.log(res)
      this.setState({ info: res.closed.ledger })
    }.bind(this))
  },

  render: function() {
    var info = this.state.info
    return React.DOM.div(null, 
      React.DOM.h2(null, "Latest ledger"), 
      React.DOM.table({className: "table table-bordered table-striped"}, 
        React.DOM.tbody(null, 
          React.DOM.tr(null, 
            React.DOM.th(null, "Close time"), 
            React.DOM.td(null, info && info.close_time_human)
          ), 
          React.DOM.tr(null, 
            React.DOM.th(null, "Hash"), 
            React.DOM.td(null, info && info.ledger_hash)
          ), 
          React.DOM.tr(null, 
            React.DOM.th(null, "Index"), 
            React.DOM.td(null, info && info.ledger_index)
          ), 
          React.DOM.tr(null, 
            React.DOM.th(null, "Total coins"), 
            React.DOM.td(null, info && (info.total_coins / 1000000))
          )
        )
      )
    )
  }
})

var Home = React.createClass({displayName: 'Home',
  render: function() {
    return React.DOM.div({className: "container"}, 
        React.DOM.h1(null, "RMC"), 
        ServerInfo(null)
      )
  }
})

module.exports = Home



//////////////////
// WEBPACK FOOTER
// ./src/routes/rmc/home/index.jsx
// module id = 465
// module chunks = 0